export class ArticuloSeccion {

	constructor() {
		this.Id = 0;
		this.referencia = '';
		this.nombre = '';
		this.cantidad_stock = 0;
		this.precio = 0;
        this.imagen = '';
        this.moneda = '';
        this.hay_stock = false;
        this.control_stock = false;
        this.vendible = false;
	}

	

    get Referencia() {return this.referencia }
    set Referencia(value) { this.referencia = value }

    get Nombre() {return this.nombre }
    set Nombre(value) { this.nombre = value }

    get CantidadStock() {return this.cantidad_stock }
    set CantidadStock(value) { this.cantidad_stock = value }

    get Precio() {return this.precio }
    set Precio(value) { this.precio = value }

    get Imagen() {return this.imagen }
    set Imagen(value) { this.imagen = value }

    get Moneda() {return this.moneda }
    set Moneda(value) { this.moneda = value }

    get Vendible() {
        return this.vendible;
    }
    set Vendible(value) { this.vendible = value }

    get ControlStock() {return this.control_stock }
    set ControlStock(value) { this.control_stock = value }
}

export class DetalleArticulo
{
	constructor() {
		this.id = 0;
		this.referencia = '';
		this.nombre = '';
		this.cantidad_stock = '';
		this.precio = 0;
        this.vendible = false;
        this.hay_stock = false;
        this.control_stock = false;
	}

    get Id() { return this.id } 
    set Id(value) { this.id = value }

    get Referencia() { return this.referencia } 
    set Referencia(value) { this.referencia = value }

    get Nombre() { return this.nombre } 
    set Nombre(value) { this.nombre = value }

    get CantidadStock() { return this.cantidad_stock } 
    set CantidadStock(value) { this.cantidad_stock = value }

    get Precio() { return this.precio }
    set Precio(value) { this.precio = value }

    get Imagen() {return this.imagen }
    set Imagen(value) { this.imagen = value }

    get Moneda() {return this.moneda }
    set Moneda(value) { this.moneda = value }

    get Vendible() {
        return this.vendible;
    }
    set Vendible(value) { this.vendible = value }
}

export class Seccion
{
    constructor() {
        this.id = 0
        this.nombre = '' 
        this.href = ''
        this.imgurl = ''
        this.css = ''
    }

    get Id() { return this.id } 
    set Id(value) { this.id = value }

    get Nombre() { return this.nombre }
    set Nombre(value) { this.nombre = value }

	get Href() { return this.href }
    set Href(value) { this.href = value }

	get ImgUrl() { return this.imgurl }
    set ImgUrl(value) { this.imgurl = value }

    get Css() { return this.css }
    set Css(value) { this.css = value }

}

